export enum StepperKey {
  CompanyConfig = 'company-config',
  Payment = 'payment',
  ProjectCreation = 'project-creation',
  Invitation = 'invitation',
}
